import httpClient, { ApiError } from '../../utilities/httpClient';
import { ToastMan } from '../../utilities/toastMan';
/**
 * Sign in with Apple on the login page. Apple's JS (appleid.auth) opens a popup that resolves with
 * the identity token; we POST it to /login/apple (the server exchanges it for a session). The user's
 * name is only present on the very FIRST authorization, so it's forwarded when Apple provides it.
 * No-ops when the button or a client id isn't present.
 */
export class AppleSignIn {
    static init() {
        const button = document.getElementById('appleSignInButton');
        if (!button)
            return;
        const clientId = button.getAttribute('data-client-id');
        if (!clientId)
            return;
        button.addEventListener('click', () => AppleSignIn.signIn(clientId, 0));
    }
    /** Apple's JS loads async, so poll briefly for it before opening the popup. */
    static signIn(clientId, attempts) {
        const apple = window.AppleID?.auth;
        if (!apple) {
            if (attempts > 50) { // ~5s — the Apple script never loaded
                ToastMan.show({ message: 'Apple sign-in failed to load. Please try again.', type: 'error', duration: 5000 });
                return;
            }
            window.setTimeout(() => AppleSignIn.signIn(clientId, attempts + 1), 100);
            return;
        }
        apple.init({
            clientId,
            scope: 'name email',
            redirectURI: window.location.origin + '/login', // must be registered on the Apple Services ID
            usePopup: true,
        });
        apple.signIn()
            .then((response) => AppleSignIn.onAuthorized(response))
            .catch(() => { });
    }
    static async onAuthorized(response) {
        const idToken = response?.authorization?.id_token;
        if (!idToken)
            return;
        // Apple sends the user's name ONLY on the very first authorization.
        const appleUser = response?.user;
        const name = appleUser?.name
            ? [appleUser.name.firstName, appleUser.name.lastName].filter(Boolean).join(' ')
            : null;
        try {
            await httpClient.post('/login/apple', { idToken, name });
            window.location.href = '/dashboard';
        }
        catch (error) {
            // Show the server's actual reason (e.g. "email already linked to a different Apple
            // account") rather than a misleading "try again".
            const message = error instanceof ApiError ? error.message : 'Apple sign-in failed. Please try again.';
            ToastMan.show({ message, type: 'error', duration: 6000 });
        }
    }
}
